import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  /* ── body scroll lock on mobile ── */
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'unset';
    return () => { document.body.style.overflow = 'unset'; };
  }, [isOpen]);

  const closeAll = () => {
    setIsOpen(false);
  };

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <nav className="navbar">
        <div className="navbar-inner">

          {/* ── LEFT: nav links ── */}
          <div className="nav-left desktop-only">
            <Link to="/"       className={`nav-link ${isActive('/') ? 'active' : ''}`}>Home</Link>
            <Link to="/about"  className={`nav-link ${isActive('/about') ? 'active' : ''}`}>About Us</Link>
            <Link to="/books"  className={`nav-link ${isActive('/books') ? 'active' : ''}`}>Services</Link>
          </div>

          {/* ── CENTER: logo ── */}
          <div className="nav-center">
            <Link to="/" className="navbar-logo" onClick={closeAll}>
              <img src="/logo.png" alt="Ritesh Shah & Co." className="nav-logo-img" />
              <img src="/ca_bg.png" alt="CA" className="nav-ca-badge-img" />
            </Link>
          </div>

          {/* ── RIGHT: Contact Us CTA + CA India logo ── */}
          <div className="nav-right desktop-only">
            <Link to="/contact" className="nav-cta-btn" onClick={closeAll}>
              Contact Us
            </Link>
            <div className="nav-right-brand">
              <img src="/ca-india-logo.png" alt="CA India" className="nav-ca-logo" />
              <div className="nav-contact-lines" aria-label="Quick contact details">
                <a href="tel:+919819771203" className="nav-contact-line">+91 9819771203</a>
                <a href="mailto:info@rscindia.com" className="nav-contact-line">info@rscindia.com</a>
              </div>
            </div>
          </div>

          {/* ── MOBILE: hamburger ── */}
          <button
            className={`navbar-toggle ${isOpen ? 'active' : ''}`}
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle menu"
          >
            <span className="bar" />
            <span className="bar" />
            <span className="bar" />
          </button>
        </div>
      </nav>

      {/* ── MOBILE DRAWER (Outside nav for better z-index/stacking) ── */}
      {isOpen && (
        <div className="mobile-backdrop" onClick={closeAll} />
      )}
      <div className={`mobile-menu ${isOpen ? 'open' : ''}`}>
        <Link to="/"       className={`mob-link ${isActive('/') ? 'active' : ''}`}       onClick={closeAll}>Home</Link>
        <Link to="/about"  className={`mob-link ${isActive('/about') ? 'active' : ''}`}  onClick={closeAll}>About Us</Link>
        <Link to="/books"  className={`mob-link ${isActive('/books') ? 'active' : ''}`}  onClick={closeAll}>Services</Link>
        <Link to="/contact" className="mob-cta"                                           onClick={closeAll}>Contact Us</Link>

        {/* Contact info block in drawer */}
        <div className="mob-contact-info">
          <a href="tel:+919819771203" className="mob-contact-item">
            <span className="mob-contact-icon">📞</span>
            +91 9819771203
          </a>
          <a href="mailto:info@rscindia.com" className="mob-contact-item">
            <span className="mob-contact-icon">✉️</span>
            info@rscindia.com
          </a>
        </div>
      </div>
    </>
  );
};

export default Navbar;
